import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import ActivitiesCard from "./ActivitiesCard";
import {
  getApprovedRewardList 
} from "../../../../../redux/employeereward/employeeRewardState";
import { Gift } from "lucide-react";

const RecentActivitySummary = ({
}) => {
  
  const dispatch = useDispatch();

  const recordList = useSelector((state) => state.employeeReward.approvedRewardList?.items);
  const pagination = useSelector((state) => state.employeeReward.approvedRewardList?.pagination);

  useEffect(() => {
    dispatch(getApprovedRewardList({paginate: pagination.per_page}));
  }, [dispatch, pagination.per_page]);

  return (
    <HeaderComponent
      title="Recent Activity"
      titleClass="text-[16px] font-medium"
      description="Latest credit awards and transactions"
      descriptionClass="text-sm muted-text"
    >
      {recordList?.length === 0 ? (
        <div className="text-center py-8">
          <Gift className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <p className="text-sm muted-text">No approved rewards yet</p>
        </div>
      ) : (
        <div className="max-h-[600px] overflow-y-auto space-y-2">
          {recordList?.map((item) => (
            <ActivitiesCard key={item?.erw_id} item={item} />
          ))}
        </div>
      )}
    </HeaderComponent>
  );
};

export default RecentActivitySummary;
